module.exports = __webpack_public_path__ + "static/img/20180414165821.d0bd77c4.jpg";